window.adsNinjaInitiator = {

    dataResponse: {
        configs: null,
        geo: {country: null, region: null, city: null},
        gamId: null,
        isBoosted: 0
    },
    brandName: null,
    shortBrandName: null,

    init: async function() {
        await this.fetchData();
        await this.loadScript();
        await this.runInjector();
    },

    fetchData: async function(){
        //nginx call
        let url = "https://adsninja.ca/urlmap?url=" + this.__getLiveHost() + window.location.pathname.toLowerCase() + "&brand=" + this.shortBrandName;
        await fetch(url)
        .then(response => response.json())
        .then(async data => {
            if (data.versions) {
                let splitted = data.versions.split("#");
                this.dataResponse.adsInjectorConfigVersion = splitted[0];
                this.dataResponse.adsInjectorVersion = splitted[1];

                let url = this.__getApiPath() + "/valnetinc/" + this.brandName + "/adsInjectorConfigs.json?v=" + this.dataResponse.adsInjectorConfigVersion;
                await fetch(url)
                .then(response => response.json())
                .then(data => {
                    this.dataResponse.configs = JSON.parse(data.configs);
                })
                .catch(error => {
                    console.error('Error :', error);
                });

            }

            if (data.geo) { 
                let splitted = data.geo.split("#");
                this.dataResponse.geo = {
                    country: splitted[0],
                    region: splitted[1],
                    city: splitted[2]
                }
            }

            if (data.gamId) {
                let splitted = data.gamId.split("#");
                this.dataResponse.gamId = splitted[0];
                this.dataResponse.isBoosted = splitted[1];
                
            }
        })
        .catch(error => {
            console.error('Error :', error);
        });

        console.log("ADS INITIATOR ---", this.dataResponse);
    },

    __getLiveHost: function (){

        let liveHost = window.location.host;

        let urlParts = liveHost.split('.');
        let QAEnvRegex = /^qa\d+$/;

        if (urlParts[0] !== 'www' && (urlParts[0] == 'ads' || QAEnvRegex.test(urlParts[0]))) {
            liveHost = liveHost.replace(urlParts[0], 'www');
        }


        return liveHost;
    },

    loadScript: async function() {
        let url =  this.__getPath() + "/ads_injector.js?v=" + this.dataResponse.adsInjectorVersion;
        let headerScriptElement = document.createElement("script");
        headerScriptElement.src = url;
        document.head.appendChild(headerScriptElement);
        //waiting for the script to load
        await new Promise((resolve) => {
            headerScriptElement.onload = resolve;
        });

    },

    runInjector: async function() {

        window.ads_injector.setConfigs(this.dataResponse.configs);
        window.ads_injector.setCountry(this.dataResponse.geo.country);
        window.ads_injector.setRegion(this.dataResponse.geo.region);
        window.ads_injector.setCity(this.dataResponse.geo.city);
        window.ads_injector.setGAMId(this.dataResponse.gamId);
        window.ads_injector.setBoostedUrlData(this.dataResponse.isBoosted);

        window.ads_injector.init();
    },

    __getPath: function () {
        let url   = 'https://cdn.adsninja.ca';
        let host  = location.host;
        let parts = host.split('.');

        if(['militarydev.prod.acquia-sites.com'].includes(window.location.hostname)){

            url = 'https://ads.adsninja.ca/cached';
        }
        else if(3 === parts[0].length && (parts[0].indexOf('qa') != -1 || parts[0].indexOf('ads') != -1)){

            url = 'https://' + parts[0] + '.adsninja.ca/cached';
        }
        else if(-1 === ['com', 'ca', 'net', 'co', 'uk', 'org'].indexOf(parts[parts.length - 1])){

            url = 'https://www.adsninja.ca.' + parts[parts.length - 1] + '/cached';
        }
        return url;
    },

    __getApiPath: function () {
        let url   = 'https://cdn.adsninja.ca/api/cached';
        let host  = location.host;
        let parts = host.split('.');

        if(['militarydev.prod.acquia-sites.com'].includes(window.location.hostname)){

            url = 'https://ads.adsninja.ca/api/cached';
        }
        else if(3 === parts[0].length && (parts[0].indexOf('qa') != -1 || parts[0].indexOf('ads') != -1)){

            url = 'https://' + parts[0] + '.adsninja.ca/api/cached';
        }
        else if(-1 === ['com', 'ca', 'net', 'co', 'uk', 'org'].indexOf(parts[parts.length - 1])){

            url = 'https://www.adsninja.ca.' + parts[parts.length - 1] + '/api/cached';
        }
        return url;
    }
}   